import { inject, injectable } from "inversify";
import { IPesquisaNpsGateway } from "./IPesquisaNpsGateway";
import { IParamsObterPesquisaNps, IParamsSavePesquisaNps } from "./type";
import { DITypes } from "@/core/@types/types";
import { type HttpClient } from "../../../core/services/protocols/types";
import "reflect-metadata";

@injectable()
export default class PesquisaNpsRequest implements IPesquisaNpsGateway {
  @inject(DITypes.INDICADORES_HTTP_CLIENT)
  private httpClient!: HttpClient;

  async handleSalvarNps(params: IParamsSavePesquisaNps): Promise<boolean> {
    const response = await this.httpClient.post<IParamsSavePesquisaNps>({
      url: "/financas/PesquisaNPS/v1/salvar-respostas-pesquisa-NPS",
      body: { ...params }
    });

    return !!response;
  }

  async handleObterDadosPesquisa(): Promise<IParamsObterPesquisaNps[] | []> {
    const response = await this.httpClient.get<IParamsObterPesquisaNps[] | []>({
      url: "/financas/PesquisaNPS/v1/usuario-habilitado-pesquisa-NPS"
    });

    return response?.body || [];
  }
}
